module.exports = __webpack_public_path__ + "img/Mills_SuperOK-128.7e0af745.jpg";